import { render, staticRenderFns } from "./examineSetting.vue?vue&type=template&id=49aab31d&scoped=true"
import script from "./examineSetting.vue?vue&type=script&lang=js"
export * from "./examineSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aab31d",
  null
  
)

export default component.exports